import { withInstall } from '@jdesign-vue/utils'
import Tooltip from './src/tooltip.vue'

export const JdTooltip = withInstall(Tooltip)
export * from './src/tooltip'
export * from './src/trigger'
export * from './src/content'
export * from './src/constants'
export default JdTooltip
